module.exports = __webpack_public_path__ + "static/fonts/BM-font-package.zip?96ea05dc";